import { FC, useEffect } from 'react';
import { FieldGroup, IFormProps } from '.';
import { useField } from 'formik';
import CustomerSelectViewModel from '../Models/CustomerSelectViewModel';
import { ParticipantSelect } from 'src/Controls';

interface ICustomerSelectControlProps extends IFormProps {
	model: CustomerSelectViewModel;
}

const CustomerSelectControl: FC<ICustomerSelectControlProps> = (props) => {
	const { model, readOnly = false, setFieldValue } = props;
	const [inputProps, , helperProps] = useField(model.FullPath);

	useEffect(() => {
		helperProps.setValue(model.Value, true);
		// eslint-disable-next-line
	}, [model.Value]);

	const onChangeValue = (value: any) => {
		return setFieldValue(model.FullPath, value);
	};

	return (
		<FieldGroup
			hidden={!model.ControlVisibility}
			name={model.FullPath}
			title={model.Caption}
			width={model.Width ?? 12}
			readOnly={!model.ControlEnabling || readOnly}
			isInvalid={model.notValidClass}
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<ParticipantSelect
				{...inputProps}
				disabled={readOnly || !model.ControlEnabling}
				setValue={(c: any) => {
					return onChangeValue(c.id);
				}}
			/>
		</FieldGroup>
	);
};

export default CustomerSelectControl;
